import { useState } from 'react';
import { useDocumentsStore } from '../store';
import { DocumentCategory } from '../types';
import { DOCUMENT_CATEGORIES } from '../constants';
import { Search, X } from 'lucide-react';

export const DocumentFilters: React.FC = () => {
  const {
    searchQuery,
    selectedCategory,
    setSearchQuery,
    setSelectedCategory,
    resetFilters,
  } = useDocumentsStore();

  const [localSearch, setLocalSearch] = useState(searchQuery);

  const handleSearch = (value: string) => {
    setLocalSearch(value);
    setSearchQuery(value);
  };

  const clearSearch = () => {
    setLocalSearch('');
    setSearchQuery('');
  };

  const hasActiveFilters = searchQuery || selectedCategory;

  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row">
      {/* Search */}
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-neutral-400" />
        <input
          type="text"
          aria-label="Rechercher un document"
          value={localSearch}
          onChange={(e) => handleSearch(e.target.value)}
          placeholder="Rechercher..."
          className="w-full rounded-xl border border-neutral-300 py-2 pl-10 pr-10 focus:border-primary-500 focus:ring-2 focus:ring-primary-100"
        />
        {localSearch && (
          <button
            type="button"
            aria-label="Effacer la recherche"
            onClick={clearSearch}
            className="absolute right-3 top-1/2 -translate-y-1/2 rounded-lg p-1 hover:bg-neutral-100"
          >
            <X className="h-4 w-4 text-neutral-400" />
          </button>
        )}
      </div>

      {/* Category Filter */}
      <select
        aria-label="Filtrer par catégorie"
        value={selectedCategory || ''}
        onChange={(e) =>
          setSelectedCategory((e.target.value as DocumentCategory) || null)
        }
        className="rounded-xl border border-neutral-300 px-4 py-2 focus:border-primary-500 focus:ring-2 focus:ring-primary-100"
      >
        <option value="">Toutes les catégories</option>
        {DOCUMENT_CATEGORIES.map((cat) => (
          <option key={cat} value={cat}>
            {cat}
          </option>
        ))}
      </select>

      {/* Reset Filters */}
      {hasActiveFilters && (
        <button
          onClick={resetFilters}
          className="flex items-center gap-2 rounded-xl border border-neutral-300 px-4 py-2 text-sm font-medium text-neutral-700 transition-colors hover:bg-neutral-50"
        >
          <X className="h-4 w-4" />
          Réinitialiser
        </button>
      )}
    </div>
  );
};

